import './About Vardaan.css';
import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import logger from '../../utils/logger';
import aboutBackground from '../../assets/images/About Vardaan/About vardaan background.avif';
import sriniImage from '../../assets/images/About Vardaan/srini.avif';
import rinoImage from '../../assets/images/About Vardaan/rino.jpg';
import gopaImage from '../../assets/images/About Vardaan/Gopa Sir.webp';
import premImage from '../../assets/images/About Vardaan/prem.avif';
import susheelImage from '../../assets/images/About Vardaan/Susheel.png';
import adarshImage from '../../assets/images/About Vardaan/Adarsh.jpg';
import mohamedImage from '../../assets/images/About Vardaan/Mohamed Zaghloul.jpg';
import hossamImage from '../../assets/images/About Vardaan/Hossam Khater.png';
import thanarajahImage from '../../assets/images/About Vardaan/P. Thanarajah.jpg';
import ahmadFuadImage from '../../assets/images/About Vardaan/Ahmad Fuad Kamarazaman.jpg';
import ahmedElmaghrabyImage from '../../assets/images/About Vardaan/ahmed elmaghraby.webp';
import youshaImage from '../../assets/images/About Vardaan/Yousha.png';
import jaheerImage from '../../assets/images/About Vardaan/Jaheer.jpeg';
import pradeepManiImage from '../../assets/images/About Vardaan/Mani pradeep.png';
import praharshithaImage from '../../assets/images/About Vardaan/praharshitha.png';

const leadershipData = [
  {
    title: 'Rino Sabatino',
    subtitle: 'Board Director – Vardaan Group of Companies',
    description:
      'Over the past fifteen years, Rino Sabatino has served as Chief Executive Officer and Chairman across major international enterprises, including family-owned businesses, multinational corporations, global investment funds, and a sovereign wealth entity. He brings a distinguished track record in leading complex organizations, driving strategic transformation, and delivering sustained value creation on a global scale.',
    imageSrc: null, // Using local images only
  },
  {
    title: 'Srinivasu V',
    subtitle: 'Board Director - Vardaan Group of Companies',
    description:
      "Srinivasu V, known as Srini, is a seasoned professional with over many years of diverse experience in various domains. Hailing from Bangalore, India, Srini is a management accountant with a Master's in Commerce, combining financial expertise with a deep understanding of technology. Srini holds a post-graduation in Commerce from Andhra University along with a professional qualification from the Institute of Cost and Management Accountants – India. Throughout his extensive career, Srini has made significant contributions across industries including manufacturing, hospitality, IT, sourcing, and even within the dynamic landscape of Unicorns. His areas of proficiency span logistics, accounting, reporting, outsourcing, advisory, and transformation. Srini's unique blend of financial acumen and technical prowess positions him as a valuable techno-functional resource. His insights have been instrumental in driving efficiency and growth in the organizations he's been a part of. With an innate ability to bridge the gap between financial strategies and technological implementations, Srini has consistently delivered solutions that optimize processes and enhance overall business performance. In the world of ever-evolving industries, Srini remains at the forefront of innovation and adaptation. His wealth of experience, combined with his continuous pursuit of excellence, makes him an asset to any team or organization aiming to thrive in today's competitive landscape.",
    imageSrc: null, // Using local images only
  },
];

const BOARD_ORDER = ['rino', 'srinivasu'];

const getBoardOrderIndex = (title = '') => {
  const normalizedTitle = (title || '').toLowerCase();
  const index = BOARD_ORDER.findIndex((key) => normalizedTitle.includes(key));
  return index === -1 ? BOARD_ORDER.length : index;
};

const sortProfilesByBoardOrder = (profiles = []) =>
  [...profiles].sort((a = {}, b = {}) => getBoardOrderIndex(a.title) - getBoardOrderIndex(b.title));

const countryHeadsData = [
  {
    title: 'Youshah',
    subtitle: 'COUNTRY HEAD - UAE, SAUDI AND EGYPT',
    description:
      'Youshah is a highly accomplished Managing Director with a strong track record of leading organisations to achieve sustainable growth, operational excellence, and outstanding customer outcomes. He provides clear strategic direction while maintaining a hands-on understanding of day-to-day operations, ensuring business objectives are consistently met. With a strong commercial mindset and an analytical approach to decision-making, Youshah successfully navigates complex challenges, drives innovation, and adapts quickly to changing market conditions. A respected leader, Youshah is known for building high-performing teams through effective coaching, development, and motivation. He places great emphasis on fostering a positive, inclusive culture and maintaining strong relationships with clients, partners, and stakeholders.',
    imageSrc: null, // Using local images only
  },
  {
    title: 'Prem Pillai',
    subtitle: 'DIRECTOR & COUNTRY HEAD - MALAYSIA',
    description:
      "Director & Country Head, Vardaan, Malaysia Boasting an illustrious and multifaceted spanning over 8 years, Prem Subramanian Pillai (fondly called Prem) brings a wealth of expertise in the fields of audit, accounting, finance, and taxation. His vocational odyssey and professional journey, which have taken him to prominent business hubs in the UAE and India, have culminated in his current role as the Director and Country Head of Vardaan in Malaysia. In his current capacity, Prem serves as the driving force behind the operations and business development initiatives of the Vardaan team in Malaysia. His superlative leadership is not confined to the precincts of Vardaan alone; it transcends national borders, as he concurrently offers consultancy services to advisory firms domiciled in both the UAE and Singapore, thereby emblemizing his unparalleled and cosmopolitan operational perspicacity. Prior to his stewardship at Vardaan, Prem made a significant impact on the audit sector in Dubai. He distinguished himself as a senior advisor and played an integral role in the management team of a renowned Dubai-based audit firm. Paramount among Prem's discernible attributes is his unwavering and ceaseless dedication to the pursuit of erudition. He holds a master's degree in commerce from Mumbai University and is a qualified chartered accountant from India. His intellectual voracity remains unquenched, as he presently finds himself immersed in the inexorable quest to attain his CPA certification on Malaysian soil. Beyond his professional achievements, Prem is deeply passionate about fostering meaningful connections and collaborations. His expertise extends beyond guiding existing firms; he possesses a unique talent for establishing new businesses on foreign soil, starting from the ground up. His meticulous attention to detail, as well as his exceptional skills in people and network management, have set a remarkable benchmark in his endeavors in offshore company arrangements. Prem's dedication to continuous learning and mentorship is a testament to his commitment to personal and professional growth. He perpetually assumes the mantle of an ever-present fount of sagacious counsel and inspiration to neophyte staff members, embodying the quintessence of a lifelong erudite and mentor par excellence.",
    imageSrc: null, // Using local images only
  },
  {
    title: 'Jaheer Hussain Mohamed Ali Jinnah',
    subtitle: 'COUNTRY HEAD - UK',
    description:
      'Jaheer Hussain Mohamed Ali Jinnah has over 25 years of diverse IT experience, specializing in Solution Architecture and SaaS product support on AWS Cloud. He is skilled in Oracle Applications, database administration, and production support. Expert DBA across Oracle, SQL Server, PostgreSQL, Vertica, and AWS Cloud. Designed security policies, monitoring dashboards (Ignite, SiteScope), and used Cloud Health for reporting. Proficient in AWS services like GuardDuty, Detective, CloudTrail, CloudWatch, and Access Analyzer. Managed Service Control Policies across 160+ AWS accounts and worked on EC2, RDS, and PostgreSQL clusters. Experienced in multi-cloud environments including Azure, OCI, and GCP. Knowledgeable in ERP systems like Oracle E-Business Suite and PeopleSoft (HRMS, Finance, Campus). An AWS Certified Professional, he mentors tech professionals and hosts community events in the UK.',
    imageSrc: null, // Using local images only
  },
];

const teamMembersData = [
  // {
  //   title: 'Gopakumar N Kavunkal',
  //   subtitle: 'Chief Executive Officer - Vardaan Data Sciences',
  //   description:
  //     'Gopakumar is the Chief Executive Officer of Vardaan Data Science, overseeing governance, customer acquisition, product and service modeling, and operations. Appointed in March 2025, he brings extensive leadership experience spanning applications engineering, product development, sales, and operations. With over 27 years in the IT industry, Gopakumar excels at aligning key organizational functions—including Sales, Delivery, Practice, Marketing, and Human Resources—to foster a culture of excellence and drive business growth. Before joining Vardaan Data Science, he led strategic business units at companies such as Mascon, Quadrant 4, and Saksoft, delivering complex and innovative solutions across diverse industries.',
  //   imageSrc: null, // Using local images only
  // },
  {
    title: 'Ahmed Elmaghraby',
    subtitle: 'Oracle Practice Head',
    description:
      'Oracle Managing Director with over 20 years of diverse experience in the corporate sector. Graduated from the University of Brunswick, Canada, in 2004 with a major in Business Administration. Began career working with various multinational companies, developing a strong foundation in business operations and management. Held the position of Chief Financial Officer (CFO) for ten years, gaining expertise in financial leadership, strategic planning, and organizational management. Transitioned into the technology sector in 2019, focusing on Oracle solutions and digital transformation initiatives. Joined Oracle\'s headquarters in Dubai as an Oracle ERP transformation manager, overseeing more than 120 active Oracle customers. Played a pivotal role in guiding clients through system transformation and adaptation, supporting AI technology adoption to enhance companies efficiency, productivity, and ROI. In 2023, was appointed as Managing Director for Oracle Practice at Infodrive, responsible for all implementation projects across various industries, leading a team of implementors, ensuring successful delivery of Oracle solutions, and developing go-to-market strategies to drive company revenue.',
    imageSrc: null, // Using local images only
  },
  {
    title: 'Hossam Khater',
    subtitle: 'Chief Executive Officer - Exaliotech',
    description:
      'A dynamic and results-driven CEO with a deep-seated background in technology and an innate entrepreneurial mindset. Hossam core expertise lies in spearheading large-scale digital transformation initiatives, crafting robust data solutions, and strategically driving AI adoption across diverse industries. With extensive experience in the Middle East and Africa markets, he successfully navigated complex business landscapes, leveraging insights gained from roles within top-tier multinational system integrators and software editors to unlock significant value and accelerate growth.',
    imageSrc: null, // Using local images only
  },
  {
    title: 'P. Thanarajah',
    subtitle: 'Vice President - Business Development - Vardaan sdn bhd',
    description:
      'Raj is a highly accomplished President- Business Development with deep expertise in the cybersecurity domain, focusing on pre-sales, sales strategy, and business development. He has worked extensively across a variety of industries including Financial Services, Oil & Gas, Manufacturing, Healthcare, and Government-Linked Companies (GLCs). With a strategic approach, he delivers tailored cybersecurity solutions that address complex business challenges. His background in product management and channel development provides a comprehensive understanding of both technical and commercial elements, driving impactful results for his clients.',
    imageSrc: null, // Using local images only
  },
  {
    title: 'Mohamed Zaghloul',
    subtitle: 'Strategic AI & Data Leader - Exaliotech',
    description:
      'Strategic AI & Data Leader with 20+ years of experience and a Ph.D. in Computer Engineering, specializing in integrating GenAI into enterprise data ecosystems. Drive measurable business value by embedding AI into core processes, applications, and data through practical, scalable frameworks. Experienced in leading pan-regional (EMEA, MEA, Asia) AI transformations across Telecom, Public Sector, Education, and Health Insurance. End-to-end expertise spans CxO advisory, presales, solution delivery, and AI modernization — all aligned to turn advanced technology into innovation and tangible outcomes.',
    imageSrc: null, // Using local images only
  },
  {
    title: 'Ahmad Fuad Kamarazaman',
    subtitle: 'Vice President – Technology and Delivery - Vardaan sdn bhd',
    description:
      'Ahmad Fuad bin Kamarazaman is a seasoned Cybersecurity Practitioner with over 12 years of experience across financial services, healthcare, education, public sectors, and service providers. Renowned for his expertise, he excels in preventing data breaches, enhancing network security, and aligning cybersecurity strategies with business objectives. Fuad\'s holistic approach integrates technology, process improvement, and education. Beyond his professional role, he mentors aspiring professionals through a free cybersecurity career clinic, serves as an Industry Technical Advisor for Malaysian educational institutions, and blogs about open-source intelligence (OSINT) under the pseudonym "SyberSeeker," contributing actively to the cybersecurity community.',
    imageSrc: null, // Using local images only
  },
  // {
  //   title: 'Susheel Ramadoss',
  //   subtitle: 'Vice President - Vardaan Data Sciences',
  //   description:
  //     'Susheel Ramadoss is a distinguished professional with expertise in research, technology, and innovation. He has contributed significantly to AI, data science, and automation through high-impact research, publications, and industry collaborations. His achievements include leading innovative projects, securing awards, and advancing data-driven solutions.',
  //   imageSrc: null, // Using local images only
  // },
  // {
  //   title: 'Adarsh EP Balan',
  //   subtitle: 'Vice President of Product Management and Service Delivery - Vardaan Data Sciences',
  //   description:
  //     "Adarsh EP is a strategic product leader with nearly a decade of experience shaping digital products and scaling customer-centric solutions across edtech, wellness, and sports technology verticals. As Vice President of Product Management and Service Delivery at Vardaan Data Science, he spearheads the end-to-end product lifecycle—bridging strategy with execution, aligning technology with user needs, and ensuring seamless cross-functional delivery across product, engineering, sales, and customer success teams. A graduate in Electrical Engineering from IIT Bombay, Adarsh is driven by creating meaningful impact in people's lives and finding the optimal balance between art and science in product development. An avid sports enthusiast, he actively engages in practices that foster balance and well-being—from Vipassana meditation to community-led initiatives that create space for reflection, play, and shared purpose.",
  //   imageSrc: null, // Using local images only
  // },
  {
    title: 'Pradeep Mani',
    subtitle: 'Vice President-Sales - Vardaan Data Sciences',
    description:
      'Pradeep Mani is the Vice President-Sales of Vardaan Data Sciences overseeing Sales and Business Development of Vardaan products in India, which is a key focus area for our growth journey ahead. Pradeep is an Indian citizen and permanent resident card holder of Singapore, holding a master\'s degree in business administration from MDIS Singapore. Over the past twenty-two years, he has garnered extensive experience in global sales across ERP, EAM, CBS, DE, SaaS, Products, Blockchain, AI, and more. Having worked in Singapore for two decades, he brings a deep understanding of markets in India, South-East Asia, Middle East & Africa, and the Americas. Before joining Vardaan, Pradeep led sales and marketing at reputed organisations such as Yash Group, OFS, and Anantara. His contributions have spanned sales, marketing, strategic alliances, acquisitions, and operations, making a significant impact wherever he has worked.',
    imageSrc: null, // Using local images only
  },
  {
    title: 'Praharshitha',
    subtitle: 'Product Management',
    description:
      'Praharshitha works at the intersection of product, technology, and user needs. She brings a hands-on understanding of translating ideas into reliable, user-ready products, and applies this perspective to drive clear, well-considered product decisions. With an eye for both functionality and experience, she focuses on creating solutions that are practical, scalable, and intuitive for users. Praharshitha is driven by curiosity, structured thinking, and a belief that well-designed products emerge from close collaboration and a deep understanding of the problems being solved.',
    imageSrc: null, // Using local images only
  },
];

const WebsiteImpactAnimatedDescription = ({ text }) => {
  const [visibleSentences, setVisibleSentences] = useState([]);
  const descRef = useRef(null);
  const sentences = text.match(/[^.!?]+[.!?]+/g) || [text];

  useEffect(() => {
    let timeouts = [];
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sentences.forEach((_, idx) => {
            const timeout = setTimeout(() => {
              setVisibleSentences((prev) => {
                if (!prev.includes(idx)) return [...prev, idx];
                return prev;
              });
            }, idx * 600);
            timeouts.push(timeout);
          });
        } else {
          setVisibleSentences([]);
          timeouts.forEach(clearTimeout);
        }
      },
      { threshold: 0.3 }
    );
    if (descRef.current) observer.observe(descRef.current);
    return () => {
      observer.disconnect();
      timeouts.forEach(clearTimeout);
    };
  }, [sentences]);

  return (
    <div className="website-impact-desc" ref={descRef}>
      {sentences.map((sentence, idx) => (
        <span
          key={idx}
          className={`website-impact-sentence${visibleSentences.includes(idx) ? ' website-impact-sentence--visible' : ''}`}
        >
          {sentence.trim()}&nbsp;
        </span>
      ))}
    </div>
  );
};

// New AnimatedHeading component for word-by-word transition
const AnimatedHeading = ({ text, className }) => {
  const [isVisible, setIsVisible] = useState(false);
  const headingRef = useRef(null);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      { threshold: 0.3 }
    );
    if (headingRef.current) {
      observer.observe(headingRef.current);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <h2 ref={headingRef} className={`${className} animated-heading${isVisible ? " animated-heading--visible" : ""}`}>
      {text.split(" ").map((word, idx) => (
        <span
          key={idx}
          className="animated-heading-word"
          style={isVisible ? { animationDelay: `${idx * 0.25 + 0.2}s` } : {}}
        >
          {word + (idx !== text.split(" ").length - 1 ? "\u00A0" : "")}
        </span>
      ))}
    </h2>
  );
};

const Leadership = () => {
  const [expandedProfile, setExpandedProfile] = useState(null);
  const [expandedCountryHeadProfile, setExpandedCountryHeadProfile] = useState(null);
  const [expandedTeamProfile, setExpandedTeamProfile] = useState(null);
  // Initialize with local data immediately - NO LOADING STATE
  const [managementTeam, setManagementTeam] = useState(sortProfilesByBoardOrder(leadershipData));
  const [countryHeads, setCountryHeads] = useState(countryHeadsData);
  const [teamMembers, setTeamMembers] = useState(teamMembersData);
  const [loading, setLoading] = useState(false); // Set to false immediately
  const [countryHeadsLoading, setCountryHeadsLoading] = useState(false); // Set to false immediately
  const [teamLoading, setTeamLoading] = useState(false); // Set to false immediately
  const [bannerImage, setBannerImage] = useState(aboutBackground); // Default to local image

  // Helper function to get fallback image based on profile name
  const getFallbackImage = (profileName, isTeamMember = false, isCountryHead = false) => {
    if (!profileName) return null;
    
    const name = profileName.toLowerCase();
    
    // Board member images
    if (name.includes('rino')) return rinoImage;
    if (name.includes('srinivasu') || name.includes('srini')) return sriniImage;
    
    // Country head images
    if (isCountryHead) {
      if (name.includes('youshah') || name.includes('yousha')) return youshaImage;
      if (name.includes('prem')) return premImage;
      if (name.includes('jaheer') || name.includes('jinnah')) return jaheerImage;
    }
    
    // Team member images
    if (isTeamMember) {
      if (name.includes('gopakumar') || name.includes('gopa')) return gopaImage;
      if (name.includes('susheel')) return susheelImage;
      if (name.includes('adarsh')) return adarshImage;
      if (name.includes('mohamed') || name.includes('zaghloul')) return mohamedImage;
      if (name.includes('hossam') || name.includes('khater')) return hossamImage;
      if (name.includes('thanarajah') || name.includes('raj')) return thanarajahImage;
      if (name.includes('ahmad') || name.includes('fuad') || name.includes('kamarazaman')) return ahmadFuadImage;
      if (name.includes('ahmed') || name.includes('elmaghraby')) return ahmedElmaghrabyImage;
      if (name.includes('pradeep') || name.includes('mani')) return pradeepManiImage;
      if (name.includes('praharshitha')) return praharshithaImage;
    }
    
    return null;
  };

  const handleToggleProfile = (index) => {
    setExpandedProfile(expandedProfile === index ? null : index);
  };

  const handleToggleCountryHeadProfile = (index) => {
    setExpandedCountryHeadProfile(expandedCountryHeadProfile === index ? null : index);
  };

  const handleToggleTeamProfile = (index) => {
    setExpandedTeamProfile(expandedTeamProfile === index ? null : index);
  };

  // Use only local banner image - no S3 loading
  // Banner image is already set in useState default value

  // Preload images in background - doesn't block rendering
  useEffect(() => {
    // Preload all board member local images immediately with highest priority
    // These are critical above-the-fold images that must load instantly
    // Note: Images are also preloaded globally on Home page, but we ensure they're ready here too
    const boardImages = [rinoImage, sriniImage];
    boardImages.forEach((imageSrc) => {
      if (imageSrc) {
        const img = new Image();
        // Set highest fetch priority
        if ('fetchPriority' in img) {
          img.fetchPriority = 'high';
        }
        // Start loading immediately
        img.src = imageSrc;
        // Use decode API for better performance
        if (img.decode) {
          img.decode().catch(() => {});
        }
      }
    });
    // Data is already set in useState - no need to set again
  }, []);

  const renderSkeletonCards = (count = 6, rowClassName = 'leadership-row') => (
    <div className={rowClassName}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={`skeleton-${rowClassName}-${index}`} className="leadership-card-wrapper">
          <div className="leadership-card leadership-card-skeleton">
            <div className="leadership-card-image">
              <div className="leadership-skeleton-avatar" />
            </div>
            <div className="leadership-card-content">
              <div className="leadership-skeleton-text leadership-skeleton-name" />
              <div className="leadership-skeleton-text leadership-skeleton-role" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  // Preload country head and team member images in background - doesn't block rendering
  useEffect(() => {
    // Preload all local images immediately for instant display with high priority
    const allLocalImages = [
      rinoImage, sriniImage,
      youshaImage, premImage, jaheerImage,
      gopaImage, susheelImage, adarshImage,
      mohamedImage, hossamImage, thanarajahImage,
      ahmadFuadImage, ahmedElmaghrabyImage,
      pradeepManiImage,
      praharshithaImage
    ];
    
    allLocalImages.forEach((imageSrc, index) => {
      if (imageSrc) {
        const img = new Image();
        // Set high fetch priority for faster loading
        if ('fetchPriority' in img) {
          img.fetchPriority = 'high';
        }
        img.src = imageSrc;
        // Use decode API for better performance
        if (img.decode) {
          img.decode().catch(() => {});
        }
      }
    });
    // Data is already set in useState - no need to set again
  }, []);

  useEffect(() => {
    const profileElements = document.querySelectorAll('.leadership-profile');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = 1;
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, { threshold: 0.1 });
    
    profileElements.forEach(profile => {
      profile.style.opacity = 0;
      profile.style.transform = 'translateY(30px)';
      profile.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(profile);
    });
    
    return () => {
      profileElements.forEach(profile => observer.unobserve(profile));
    };
  }, []);
  
  useEffect(() => {
    const handleResize = () => {
      document.querySelectorAll('.leadership-profile').forEach(profile => {
        profile.style.display = 'none';
        setTimeout(() => {
          profile.style.display = '';
        }, 0);
      });
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <div className="leadership-page">
      <div className="leadership-hero-banner">
        <img 
          src={bannerImage} 
          alt="About Vardaan Background" 
          className="leadership-banner-image"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
        <div className="leadership-banner-overlay"></div>
        <div className="leadership-header-content">
          {/* Our Approach and Commitment Section - Overlaid on Banner */}
          <div className="website-impact-overlay">
            <div className="website-impact-container">
              <div className="website-impact-left">
                <h2 className="website-impact-title">Our Approach and Commitment</h2>
                <p className="website-impact-desc">Through a combination of <span style={{whiteSpace: 'nowrap'}}>in-house expertise</span> and a <span style={{whiteSpace: 'nowrap'}}>robust partner ecosystem</span>, we are dedicated to<span style={{whiteSpace: 'nowrap'}}> empowering organisations</span> to enhance efficiency, build resilience, and stay ahead in a rapidly changing landscape.</p>
              </div>
              <div className="website-impact-right">
                <h2 className="website-impact-subtitle">Our Solutions and Impact</h2>
                <p className="website-impact-desc">Our deep strategic insight into the drivers of enterprise growth enables us to help clients achieve secured operations, operational excellence, compliance readiness, and scalable innovation.</p>
                <p className="website-impact-desc">Our portfolio includes AI-powered tools and intelligent platforms—ranging from GRC intelligence platforms and smart logistics systems to audit management suites, camera vision AI, digital workers, robotic automation, and cybersecurity solutions—all designed to deliver actionable insights and measurable business impact.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* New Leadership Section */}
      <section className="leadership-section">
        <div className="leadership-section-container">
          <h2 className="leadership-section-title">Our Board Members</h2>
          
          <div className="leadership-grid">
            {loading ? (
              renderSkeletonCards(Math.max(managementTeam.length, 6), "leadership-row leadership-row-single")
            ) : (
              <>
                {/* Single Row - All 4 members */}
                <div className="leadership-row leadership-row-single">
                  {managementTeam.map((profile, index) => (
                    <div key={profile.id || index} className="leadership-card-wrapper">
                      <div className="leadership-card">
                        <div className="leadership-card-image">
                          <img 
                            src={getFallbackImage(profile.title)} 
                            alt={profile.title} 
                            loading="eager"
                            fetchPriority="high"
                            decoding="async"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              logger.error(`Failed to load image for ${profile.title}`);
                            }}
                          />
                        </div>
                        <div className="leadership-card-content">
                          <h3 className="leadership-card-name">{profile.title}</h3>
                          <p className="leadership-card-designation">{profile.subtitle}</p>
                          <button 
                            className="leadership-toggle-btn"
                            onClick={() => handleToggleProfile(index)}
                          >
                            {expandedProfile === index ? '−' : '+'}
                          </button>
                        </div>
                      </div>
                      
                      {/* Individual Expanded Content for Mobile */}
                      {expandedProfile === index && (
                        <div className="leadership-expanded-individual">
                          <div className="leadership-expanded-content">
                            <div className="leadership-expanded-inner">
                              <div className="leadership-expanded-description">
                                <p>{profile.description}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                
                {/* Expanded Description for All Members - Desktop Only */}
                {expandedProfile !== null && (
                  <div className="leadership-expanded-row desktop-only">
                    <div className="leadership-expanded-content">
                      <div className="leadership-expanded-inner">
                        <div className="leadership-expanded-description">
                          <p>{managementTeam[expandedProfile]?.description || ''}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </section>
      
      {/* Country Heads Section */}
      <section className="leadership-section country-heads-section">
        <div className="leadership-section-container">
          <h2 className="leadership-section-title">Country Heads</h2>
          
          <div className="leadership-grid">
            {countryHeadsLoading ? (
              renderSkeletonCards(Math.max(countryHeads.length, 6), "leadership-row leadership-row-country-heads")
            ) : (
              <>
                {/* Single Row - All 3 country heads */}
                <div className="leadership-row leadership-row-country-heads">
                  {countryHeads.map((profile, index) => (
                    <div key={profile.id || `country-head-${index}`} className="leadership-card-wrapper">
                      <div className="leadership-card">
                        <div className="leadership-card-image">
                          <img 
                            src={getFallbackImage(profile.title, false, true)} 
                            alt={profile.title} 
                            loading="eager"
                            fetchPriority="high"
                            decoding="async"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              logger.error(`Failed to load image for ${profile.title}`);
                            }}
                          />
                        </div>
                        <div className="leadership-card-content">
                          <h3 className="leadership-card-name">{profile.title}</h3>
                          <p className="leadership-card-designation">{profile.subtitle}</p>
                          <button 
                            className="leadership-toggle-btn"
                            onClick={() => handleToggleCountryHeadProfile(index)}
                          >
                            {expandedCountryHeadProfile === index ? '−' : '+'}
                          </button>
                        </div>
                      </div>
                      
                      {/* Individual Expanded Content for Mobile */}
                      {expandedCountryHeadProfile === index && (
                        <div className="leadership-expanded-individual">
                          <div className="leadership-expanded-content">
                            <div className="leadership-expanded-inner">
                              <div className="leadership-expanded-description">
                                <p>{profile.description}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                
                {/* Expanded Description for All Members - Desktop Only */}
                {expandedCountryHeadProfile !== null && (
                  <div className="leadership-expanded-row desktop-only">
                    <div className="leadership-expanded-content">
                      <div className="leadership-expanded-inner">
                        <div className="leadership-expanded-description">
                          <p>{countryHeads[expandedCountryHeadProfile]?.description || ''}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </section>
      
      {/* Our Team Members Section */}
      <section className="leadership-section team-section">
        <div className="leadership-section-container">
          <h2 className="leadership-section-title">Our Team Members</h2>
          
          <div className="leadership-grid">
            {teamLoading ? (
              renderSkeletonCards(Math.max(teamMembers.length, 6), "leadership-row leadership-row-team")
            ) : (
              <>
                {/* Team Members Grid - Grouped into rows of 3 */}
                {(() => {
                  const rows = [];
                  const membersPerRow = 3;
                  
                  for (let i = 0; i < teamMembers.length; i += membersPerRow) {
                    const rowMembers = teamMembers.slice(i, i + membersPerRow);
                    const rowIndex = Math.floor(i / membersPerRow);
                    const rowStartIndex = i;
                    
                    rows.push(
                      <React.Fragment key={`team-row-${rowIndex}`}>
                        <div className="leadership-row leadership-row-team">
                          {rowMembers.map((profile, colIndex) => {
                            const globalIndex = rowStartIndex + colIndex;
                            return (
                              <div key={profile.id || `team-${globalIndex}`} className="leadership-card-wrapper">
                                <div className="leadership-card">
                                  <div className="leadership-card-image">
                                    <img 
                                      src={getFallbackImage(profile.title, true)} 
                                      alt={profile.title} 
                                      loading={globalIndex < 10 ? "eager" : "lazy"}
                                      fetchPriority={globalIndex < 10 ? "high" : "auto"}
                                      decoding="async"
                                      onError={(e) => {
                                        e.target.style.display = 'none';
                                        logger.error(`Failed to load image for ${profile.title}`);
                                      }}
                                    />
                                  </div>
                                  <div className="leadership-card-content">
                                    <h3 className="leadership-card-name">{profile.title}</h3>
                                    <p className="leadership-card-designation">{profile.subtitle}</p>
                                    <button 
                                      className="leadership-toggle-btn"
                                      onClick={() => handleToggleTeamProfile(globalIndex)}
                                    >
                                      {expandedTeamProfile === globalIndex ? '−' : '+'}
                                    </button>
                                  </div>
                                </div>
                                
                                {/* Individual Expanded Content for Mobile */}
                                {expandedTeamProfile === globalIndex && (
                                  <div className="leadership-expanded-individual">
                                    <div className="leadership-expanded-content">
                                      <div className="leadership-expanded-inner">
                                        <div className="leadership-expanded-description">
                                          <p>{profile.description}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                        
                        {/* Expanded Description for Desktop - Appears below the row containing the clicked member */}
                        {expandedTeamProfile !== null && 
                         expandedTeamProfile >= rowStartIndex && 
                         expandedTeamProfile < rowStartIndex + membersPerRow && (
                          <div className="leadership-expanded-row desktop-only">
                            <div className="leadership-expanded-content">
                              <div className="leadership-expanded-inner">
                                <div className="leadership-expanded-description">
                                  <p>{teamMembers[expandedTeamProfile]?.description || ''}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </React.Fragment>
                    );
                  }
                  return rows;
                })()}
              </>
            )}
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Leadership; 